import { render, staticRenderFns } from "./invoice-editor.vue?vue&type=template&id=13fd340b&scoped=true&"
import script from "./invoice-editor.vue?vue&type=script&lang=js&"
export * from "./invoice-editor.vue?vue&type=script&lang=js&"
import style0 from "./invoice-editor.vue?vue&type=style&index=0&id=13fd340b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13fd340b",
  null
  
)

export default component.exports